export const firebaseKeys = {
  apiKey: "AIzaSyCXdbKsEuHGxmr0z2j-M4TxqnoyQVH43RU",
  authDomain: "plin-kurz.firebaseapp.com",
  databaseURL: "https://plin-kurz.firebaseio.com",
  projectId: "plin-kurz",
  storageBucket: "",
  messagingSenderId: "766536944933",
  appId: "1:766536944933:web:c1cb0c8f4eb371c9"
}